// extracted by mini-css-extract-plugin
export var content_palette = "palette_post-module--content_palette--52119";
export var hex_code = "palette_post-module--hex_code--7ff72";
export var mini_color = "palette_post-module--mini_color--5d456";
export var mini_palette = "palette_post-module--mini_palette--8f27a";
export var more_palettes_button = "palette_post-module--more_palettes_button--78c61";
export var more_palettes_button_container = "palette_post-module--more_palettes_button_container--4d5d3";
export var palette_image = "palette_post-module--palette_image--f1618";
export var palette_post_wrapper = "palette_post-module--palette_post_wrapper--18ab7";
export var palettes_lists_wrapper = "palette_post-module--palettes_lists_wrapper--35050";